import { useQuery } from '@tanstack/react-query';
import api from '../api/client';

export interface UnidadeMedida {
  id: number;
  sigla: string;
  descricao: string;
}

interface UnidadesMedidaResponse {
  unidadesMedida: UnidadeMedida[];
}

export const useUnidadesMedida = () => {
  return useQuery({
    queryKey: ['unidades-medida'],
    queryFn: async () => {
      const response = await api.get<UnidadesMedidaResponse>('/unidades-medida');
      return response.data.unidadesMedida;
    },
  });
};
